import { ShaderMaterial, Vector3 } from 'three'

export default class RefractionMaterial extends ShaderMaterial {
  constructor(options) {
    super({
      ...options,
      vertexShader: `
      varying vec3 worldNormal;
      #ifndef IS_BACKFACE
        varying vec3 viewDirection;
      #endif
      void main() {

        vec4 transformedNormal = vec4(normal, 0.);
        vec4 transformedPosition = vec4(position, 1.0);
        #ifdef USE_INSTANCING
          transformedNormal = instanceMatrix * transformedNormal;
          transformedPosition = instanceMatrix * transformedPosition;
        #endif

        worldNormal = normalize( modelViewMatrix * transformedNormal).xyz;
        #ifndef IS_BACKFACE
          vec4 worldPosition = modelMatrix * vec4( position, 1.0);
          viewDirection = normalize(worldPosition.xyz - cameraPosition);
        #endif
        gl_Position = projectionMatrix * modelViewMatrix * transformedPosition;
      }`,
      fragmentShader: `
      varying vec3 worldNormal;
      #ifndef IS_BACKFACE
        uniform sampler2D envMap;
        uniform sampler2D backfaceMap;
        uniform vec2 resolution;
        uniform float fresnelRange;
        varying vec3 viewDirection;
        const float ior = 1.5;
        const float a = 0.33;
        #ifdef USE_FRESNEL
          uniform vec3 reflectionColor;
          float fresnelFunc(vec3 viewDirection, vec3 worldNormal) {
            return pow( fresnelRange + dot( viewDirection, worldNormal), 10.0 );
          }
        #endif
      #endif
      
      void main() {
        #ifdef IS_BACKFACE
            // Backface material
            gl_FragColor = vec4(worldNormal, 1.);
        #else
            // Refraction material
            vec2 uv = gl_FragCoord.xy / resolution;
            vec3 backfaceNormal = texture2D(backfaceMap, uv).rgb;
            vec3 normal = worldNormal * (1.0 - a) - backfaceNormal * a;
            vec3 refracted = refract(viewDirection, normal, 1.0/ior);
            uv += refracted.xy;
            #ifdef USE_FRESNEL
              vec4 tex = texture2D(envMap, uv);
              float fresnel = fresnelFunc(viewDirection, normal);
              vec3 color = mix(tex.rgb, reflectionColor, fresnel);
              gl_FragColor = vec4(color, 1.0);
            #else
              gl_FragColor = texture2D(envMap, uv);
            #endif
        #endif
      }`,
    })
  }
}
